import { CircularProgress } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React, { RefObject, useEffect, useState } from 'react';
import { fetchProtectedImg } from '../../utils/fetchProtectedImg';

interface ProtectedImgProps {
  src?: string;
  imgData?: Blob;
  style?: CSSProperties;
  className?: string | undefined;
  onClick?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
  forceReload?: boolean;
  onLoad?: () => void;
  onInit?: () => void;
  imgRef?: RefObject<HTMLImageElement>;
  alt?: string;
  uploadInProgress?: boolean;
}

const ProtectedImg: React.FC<ProtectedImgProps> = (props) => {
  const { forceReload, onLoad, onInit, imgRef, imgData, alt, uploadInProgress, ...restProps } = props;

  const [imgSource, setImgSource] = useState<string>();
  const [isErrorFound, setIsErrorFound] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(false);
    onInit?.();
    try {
      if (imgData) {
        setImgSource(window.URL.createObjectURL(imgData));
      } else if (props.src || forceReload) {
        fetchProtectedImg(props.src!)
          .then((objectURL: string) => {
            setImgSource(objectURL);
            setIsErrorFound(false);
          })
          .catch(() => {
            setIsErrorFound(true);
          });
      }
    } catch {
      setIsErrorFound(true);
    }
  }, [props.src, imgData, forceReload, onInit]);

  const handleImgLoad = () => {
    onLoad && onLoad();
    setIsLoaded(true);
  };

  if (imgSource) {
    return (
      <div>
        <img
          style={{ maxWidth: '100%' }}
          ref={imgRef}
          {...restProps}
          src={imgSource}
          alt={alt ?? 'obraz rozwiązania zadania'}
          onLoad={handleImgLoad}
        />
        {uploadInProgress && (
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress />
          </div>
        )}
      </div>
    );
  } else if (isErrorFound) {
    return <ErrorOutlineIcon />;
  } else if (!isLoaded) {
    return (
      <div {...restProps}>
        <div style={{ margin: '10px' }}>
          <CircularProgress />
        </div>
      </div>
    );
  } else return <></>;
};

export default React.memo(ProtectedImg);
